(function(){
  var focusSelector='a[href],area[href],button,input,select,textarea,summary,video[controls],audio[controls],[tabindex]:not([tabindex="-1"]),[contenteditable="true"]';
  var managed='data-rgd-a11y-tabindex';
  var container='data-rgd-a11y-managed';
  var hiddenSelector='.rf-video-products[aria-hidden="true"],.rf-video-item[aria-hidden="true"],.carousel-cell[aria-hidden="true"],[class*="rf-video"][aria-hidden="true"]';
  var visibleSelector='['+container+']:not([aria-hidden="true"])';
  var scheduled=false;
  function each(list,callback){Array.prototype.forEach.call(list,callback)}
  function hideFocusables(scope){
    if(!scope||scope.nodeType!==1)return;
    if(!scope.querySelector(focusSelector))return;
    scope.setAttribute(container,'true');
    if('inert'in scope)scope.inert=true;
    each(scope.querySelectorAll(focusSelector),function(el){
      if(!el.hasAttribute(managed))el.setAttribute(managed,el.getAttribute('tabindex')||'');
      el.setAttribute('tabindex','-1');
    });
  }
  function restoreFocusables(scope){
    if(!scope||scope.nodeType!==1)return;
    if('inert'in scope)scope.inert=false;
    scope.removeAttribute('inert');
    scope.removeAttribute(container);
    each(scope.querySelectorAll('['+managed+']'),function(el){
      var old=el.getAttribute(managed);
      if(old==='')el.removeAttribute('tabindex');else el.setAttribute('tabindex',old);
      el.removeAttribute(managed);
    });
  }
  function scan(root){
    var scope=root&&root.nodeType===1?root:document;
    each(scope.querySelectorAll(visibleSelector),restoreFocusables);
    if(scope.matches&&scope.matches(visibleSelector))restoreFocusables(scope);
    each(scope.querySelectorAll(hiddenSelector),hideFocusables);
    if(scope.matches&&scope.matches(hiddenSelector))hideFocusables(scope);
  }
  function schedule(root){
    if(scheduled)return;
    scheduled=true;
    (window.requestIdleCallback||function(cb){setTimeout(cb,120)})(function(){scheduled=false;scan(root||document)});
  }
  function start(){
    scan(document);
    if(!document.body)return;
    new MutationObserver(function(mutations){
      for(var i=0;i<mutations.length;i++){
        var m=mutations[i];
        if(m.type==='attributes'||m.addedNodes.length){schedule(document);break}
      }
    }).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['aria-hidden']});
    window.addEventListener('pageshow',function(){schedule(document)},{passive:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
